import { SELECT_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";
import { PRICE_MANAGEMENT_OPTIONS } from "@utils/Constants";

const PriceManagementFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "pricemanaged",
                        "label": "Como se manejaran los precios",
                        "sizing": {
                            "sm": 5
                        },
                        "options": PRICE_MANAGEMENT_OPTIONS,
                        "validation": Yup.string().required(),
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "percent_per_item",
                        "label": "Permitir modificar el porcentaje de ganancia en cada producto",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ]
            ]
        }
    ],
};


export default PriceManagementFormConfig;